import {
  AP_EAST_1_SOUTH_AMERICA,
  AP_SOUTH_EAST_2_ASIA_PACIFIC,
  EU_WEST_2_EUROPE,
  GenesysCloudAPIRegion,
  US_EAST_1,
} from '@dictionaries/genesys-cloud-aws-region-dictionary';
import {
  APACRegionCountryCodes,
  EMEARegionountryCodes,
  LATAMRegionCountryCodes,
  NARegionCountryCodes,
  RegionCode,
} from '@enums/region-country-codes.enums';

/**
 * Return region code based on country code
 * @param countryCode - ISO 2 character country code
 * @returns RegionCode enum
 */
export function getRegionByCountryCode(countryCode: string): RegionCode {
  if (isValidCountryInNARegion(countryCode)) {
    return RegionCode.NA;
  } else if (isValidCountryInEMEARegion(countryCode)) {
    return RegionCode.EMEA;
  } else if (isValidCountryInAPACRegion(countryCode)) {
    return RegionCode.APAC;
  } else if (isValidCountryInLATAMRegion(countryCode)) {
    return RegionCode.LATAM;
  } else {
    // Default to NA Region
    return RegionCode.NA;
  }
}

/**
 * Return AWS Region based on region and country code
 * @param countryCode - ISO 2 character country code
 * @returns GenesysCloudRegion enum
 */
export function getAWSRegionByCountryCode(countryCode: string): GenesysCloudAPIRegion {
  if (isValidCountryInNARegion(countryCode)) {
    return US_EAST_1;
  } else if (isValidCountryInEMEARegion(countryCode)) {
    return EU_WEST_2_EUROPE;
  } else if (isValidCountryInAPACRegion(countryCode)) {
    return AP_SOUTH_EAST_2_ASIA_PACIFIC;
  } else if (isValidCountryInLATAMRegion(countryCode)) {
    return AP_EAST_1_SOUTH_AMERICA;
  } else {
    // Default to NA Region
    return US_EAST_1;
  }
}

/**
 * Return boolean if country code is part of the NA (North America) Region
 * @param countryCode - ISO 2 character country code
 * @returns boolean indicating if the value is a NA Region country code enum
 */
export function isValidCountryInNARegion(countryCode: string): boolean {
  return Object.values(NARegionCountryCodes).includes(countryCode as NARegionCountryCodes);
}

/**
 * Return boolean if country code is part of the EMEA (Europe, Middle East, and Africa) Region
 * @param countryCode - ISO 2 character country code
 * @returns boolean indicating if the value is a EMEA Region country code enum
 */
export function isValidCountryInEMEARegion(countryCode: string): boolean {
  return Object.values(EMEARegionountryCodes).includes(countryCode as EMEARegionountryCodes);
}

/**
 * Return boolean if country code is part of the APAC (Asia Pacific) Region
 * @param countryCode - ISO 2 character country code
 * @returns boolean indicating if the value is a APAC Region country code enum
 */
export function isValidCountryInAPACRegion(countryCode: string): boolean {
  return Object.values(APACRegionCountryCodes).includes(countryCode as APACRegionCountryCodes);
}

/**
 * Return boolean if country code is part of the LATAM (Latin America) Region
 * @param countryCode - ISO 2 character country code
 * @returns boolean indicating if the value is a LATAM Region country code enum
 */
export function isValidCountryInLATAMRegion(countryCode: string): boolean {
  return Object.values(LATAMRegionCountryCodes).includes(countryCode as LATAMRegionCountryCodes);
}
